import React, { useEffect } from "react";
import "./Login.css";


const Login = () => {

    return (
        <div className="about-page">
            <div className="login-wrapper">

                <img
                    src={require("../components/images/login-banner.jpg")}
                    alt="Login Banner"
                    className="login-full-image"
                />
            </div>
        </div>
    );
};

export default Login;